import { useEffect } from 'react';
import { Form } from 'antd';
import type { FormInstance } from 'antd';
import { postingFrom } from '../../interviewer/model';
import type { Posting } from '../../services/interviewer.types';

/**
 * Reports the posting as the recruiter writes it, so Rio can draft from it.
 * Rendered only with the interviewer setup on: with it off, the job form
 * watches nothing extra and re-renders exactly as before.
 */
const PostingWatcher = ({
  form,
  onChange,
}: {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  form: FormInstance<any>;
  onChange: (posting: Posting) => void;
}) => {
  // `preserve`: the skills are filled in (by the AI extract) before their
  // step is on screen, when their fields aren't registered yet.
  const watch = { form, preserve: true };
  const title = Form.useWatch('title', watch);
  const description = Form.useWatch('description', watch);
  const requiredSkills = Form.useWatch('requiredSkills', watch);
  const preferredSkills = Form.useWatch('preferredSkills', watch);

  // Arrays come back as new objects on every render: compare them by value.
  const requiredKey = JSON.stringify(requiredSkills ?? null);
  const preferredKey = JSON.stringify(preferredSkills ?? null);

  useEffect(() => {
    onChange(
      postingFrom({
        title,
        description,
        requiredSkills: JSON.parse(requiredKey),
        preferredSkills: JSON.parse(preferredKey),
      }),
    );
  }, [title, description, requiredKey, preferredKey, onChange]);

  return null;
};

export default PostingWatcher;
